import { Component, OnInit, Input } from '@angular/core';
import { DialogConfig } from '@tmhcc-ng-lib/framwork/dialog';
import { Router } from '@angular/router';

@Component({
  selector: 'ae-endorsement-modal',
  templateUrl: './popup-modal.component.html',
  styleUrls: ['./popup-modal.component.scss']
})
export class PopupModalComponent implements OnInit {
    constructor(public dialogData: DialogConfig, private router: Router) {}
    currentUrl: string;
    renewalflag: boolean = false;
    ceContactFlad: boolean = false;
    currentSubcompany: string;
    ngOnInit(): void {
      this.currentUrl = this.router.url; 
    }
    
    noPopup() {
      this.dialogData.data.noBtnCallback();
    }
    yesPopup() {
      this.dialogData.data.yesBtnCallback();
    }
  }
  